module.exports = __webpack_public_path__ + "static/media/dorms.210df105.svg";